import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from './../router'
import store from './../vuex/store'
 
Vue.use(AclInstaller)

export default new AclCreate({
    initial: 'notAuth',
    notfound: {
        path: '/'
    },
    router,
    acceptLocalRules: true,
    globalRules: {
        isProPremium: new AclRule('pro_premium').or('pro_licence').generate(),
        isPro: new AclRule('pro').or('pro_premium').or('pro_licence').generate(),
        isUserPremium: new AclRule('user_premium').generate(),
        isUser: new AclRule('user').or('user_premium').generate(),
        isAuth: new AclRule('pro').or('user').or('pro_premium').or('user_premium').or('pro_licence').generate(),
        isNotAuth: new AclRule('notAuth').generate(),
        isProLicence: new AclRule('pro_licence').generate(),
    },
    middleware: async acl => {
        let profile = store.getters.getProfile
        if (profile.id) {
            if (
                (profile.role === 'pro' || profile.role === 'pro_premium') &&
                !profile.is_pro_status_blocked &&
                profile.current_pro_status?.type === 'licence' &&
                !profile.is_aja
            ) {
                return acl.change('pro_licence')
            }
            if (profile.types.indexOf('premium') >= 0)
                return acl.change(profile.role+'_premium')
            return acl.change(profile.role)
        }
        return acl.change('notAuth')
    }
})